import "./application.scss"
import { createApp } from "vue"
import router from "../src/router/index"
import { key, store } from "../src/stores/index"
import { vuetify } from "../src/plugins/vuetify"
import App from "../src/App.vue"
import { loadFonts } from "../src/plugins/webfontloader"
import VueGtag from "vue-gtag"

loadFonts()

const app = createApp(App)
  .use(router)
  .use(vuetify)
  .use(store, key)

if(process.env.SERVER_ENV === "production") {
  app.use(VueGtag, {
    config: { id: "G-JCNVJ703TV" }
  }, router)
}

router.isReady().then(() => {
  app.mount("#vue-app")
})
